exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".work-schedules-list-management-page[data-v-7337b91e] {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
